import useSWRMutation from "swr/mutation";
import { http } from "~/services/http";

/**
 * Fetcher for useSWRMutation that:
 *  - Returns `{ success: true }` on 2xx.
 *  - Returns `{ success: false, hardViolations: [...] }` on HTTP 400
 *    when the body contains a `hardViolations` array.
 *  - Returns `{ success: false, message }` on HTTP 400 without a
 *    structured body (preserves existing behaviour).
 *  - Re-throws for any other non-2xx (network error, 5xx, etc.) so
 *    the caller's `catch` block still handles those cases.
 */
async function sendFormFetcher(url, { arg: body }) {
  try {
    await http.post(url, { arg: body });
    return { success: true };
  } catch (response) {
    // http.post rejects with the raw Response object for non-2xx statuses.
    if (response?.status === 400) {
      try {
        const data = await response.json();
        if (Array.isArray(data?.hardViolations)) {
          return { success: false, hardViolations: data.hardViolations };
        }
        // 400 but no structured body — surface the message if present.
        return { success: false, message: data?.message ?? data };
      } catch (_) {
        return { success: false };
      }
    }
    // Re-throw for 5xx, network errors, etc.
    throw response;
  }
}

export const useSendForm = (eventId) => {
  const { trigger: sendForm, isMutating: isSending } = useSWRMutation(
    `/api/quest/${eventId}`,
    sendFormFetcher,
    { revalidate: false }
  );

  return { sendForm, isSending };
};
